import ReactPlayer from 'react-player';
import ch2_img1 from 'assets/knowledge/ch2_img1.png';
import ch2_img2 from 'assets/knowledge/ch2_img2.png';
import ch2_img3 from 'assets/knowledge/ch2_img3.png';
import ch2_img4 from 'assets/knowledge/ch2_img4.png';
import ch2_img5 from 'assets/knowledge/ch2_img5.png';




const Chapter2 = () => {
  return <div>
  <h2>Kurze Einführung</h2>
  <ReactPlayer url="https://youtu.be/gOpz7jhcIV4" controls width="100%" />
  <h3>1. Fuhrpark anlegen</h3>
  <p>In der Flotte findet man die Übersicht aller Fahrzeuge der einzelnen Fuhrparks. Per Klick auf die Schaltfläche "Fuhrpark hinzufügen" kann man weitere Fuhrparks erstellen. Die Anzahl ist nicht limitiert und je Fuhrpark können beliebig viele Fahrzeuge hinzugefügt werden.</p>
  <img src={ch2_img1} alt="CO2OPT Übersicht" />
  <p>Nach Klick auf „Fuhrpark hinzufügen“ öffnet sich ein Fenster, bei dem man nur noch den gewünschten Namen und den Standort der Flotte eingeben muss. Abschließend klickt man auf „Bestätigen“ und die neue Flotte ist erstellt. Sie ist nun links in der Flottenliste aufgeführt</p>
  <img src={ch2_img2} alt="CO2OPT Übersicht2" />
  <h3>2. Fuhrpark löschen</h3>
  <p>Um eine Flotte zu löschen, geht man einfach in die jeweilige Flotte und klickt dann auf das Mülltonnensymbol neben der Suchleiste.
</p>
  <img src={ch2_img3} alt="Dashboard Ansicht3" />

<p>Es öffnet sich nun ein weiteres Fenster, bei dem man ggf. auch noch andere Flotten auswählen kann. </p>

<img src={ch2_img4} alt="Flottenübersicht4" />
<p>Zur Sicherheit wird man erneut gefragt, ob man wirklich sicher ist, dass man die Flotte löschen möchte, da mit dem Löschen der Flotte alle Fahrzeuge und Reifen, die sich in diesem Fuhrpark befinden ebenfalls gelöscht werden und auch nicht mehr hergestellt werden können. Nach dem Klick auf „Bestätigen“ ist die Flotte gelöscht und taucht auch nicht mehr in der Liste links auf.
</p>
<img src={ch2_img5} alt="Flottenübersicht5" />
</div>
};

export default Chapter2;